module.exports = __webpack_public_path__ + "img/about_sharecode_2.a6165219.png";